import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CgClose } from "react-icons/cg";
import axios from "axios";
import { api } from "../../../../../../../../../api";
import ButtonBlack from "../../../../../../../../components/Buttons/ButtonBlack";

const DeclineApplicationModal = ({show= false, onClose, showStatusModal, setShowStatusModal, applicationId }) => {
  const [motif, setMotif] = useState("");
  const [message, setMessage] = useState("");
  const [sendEmail, setSendEmail] = useState(true);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const motifs = [
    "Profil non adapté",
    "Manque d'expérience",
    "Salaire hors budget",
    "Autre (précisez dans le message)",
  ];

  const handleDeclineApplication = async () => {
    // try {
      await axios.post(`${api}/applications/${applicationId}/reject`, {
        reason_for_decline: motif,
        comment: message,
        send_email: sendEmail,
      })
      .then((response)=>{
        setShowConfirmModal(false);
        console.log(response.data)
        // onUpdate(); // Rafraîchir les données après mise à jour
        onClose(); // Fermer le modal
      }).catch ((error)=> {
      console.error("Erreur lors du refus de la candidature :", error);
    }).finally (()=>{
      setLoading(false);
    })
    //   onClose();
    // } catch (error) {
    //   console.error("Erreur lors du refus de la candidature", error);
    // }
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed z-40 bg-gray-900/10 top-0 bottom-0 left-0 right-0 flex justify-end backdrop-blur-sm"
        >
          <motion.div
            initial={{ opacity: 0, right: "-100%", y: 20 }}
            animate={{ opacity: 1, right: 0, y: 0 }}
            exit={{ opacity: 0, right: "-100%", y: 20 }}
            transition={{ type: "spring", stiffness: 130, damping: 20 }}
            className="fixed overflow-y-auto bg-white w-full lg:w-2/3 xl:w-1/2 min-h-full lg:rounded-s-2xl drop-shadow-lg"
          >
            {/* Header */}
            <div className="flex justify-between py-4 border-b px-6">
              <h4 className="text-lg font-bold">Décliner la candidature</h4>
              <button onClick={onClose}>
                <CgClose />
              </button>
            </div>

            {/* Avertissement */}
            <div className="flex p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50" role="alert">
              <svg className="shrink-0 inline w-4 h-4 me-3 mt-[2px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
              </svg>
              <div>
                <span className="font-medium">Attention :</span>
                <ul className="mt-1.5 list-disc list-inside">
                  <li>Cette action est irréversible.</li>
                  <li>Le candidat sera notifié si l'option email est activée.</li>
                  <li>Vérifiez bien le motif et le message.</li>
                </ul>
              </div>
            </div>

            {/* Formulaire */}
            <div className="px-6 space-y-4 mt-4">
              {/* Sélection du motif */}
              <select
                className="border rounded-md w-full p-2 bg-gray-50 focus:outline-none"
                value={motif}
                onChange={(e) => setMotif(e.target.value)}
              >
                <option value="">Sélectionner un motif de refus</option>
                {motifs.map((mot, index) => (
                  <option key={index} value={mot}>
                    {mot}
                  </option>
                ))}
              </select>

              {/* Message */}
              <textarea
                className="h-[200px] border rounded-md w-full p-2 bg-gray-50 focus:outline-none"
                placeholder="Message pour le candidat..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />

              {/* Option d'envoi d'email */}
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={sendEmail}
                  onChange={() => setSendEmail(!sendEmail)}
                />
                <span>Envoyer un email au candidat</span>
              </label>

              {/* Boutons */}
              <div className="flex justify-end space-x-4">
                <button
                  onClick={() => setShowStatusModal(false)}
                  className="text-black bg-gray-200 rounded-md px-4 py-2 hover:bg-gray-300"
                >
                  Annuler
                </button>
                <button
                  onClick={() => setShowConfirmModal(true)}
                  className="text-white bg-red-500 rounded-md px-4 py-2 hover:opacity-80"
                >
                  Décliner et envoyer
                </button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}

      {/* Modal de confirmation */}
      <AnimatePresence>
        {showConfirmModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/30 flex justify-center items-center z-[999]"
          >
            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              className="bg-white p-6 rounded-lg shadow-lg"
            >
              <h4 className="text-lg font-bold mb-4">Confirmer le refus</h4>
              <p>Êtes-vous sûr de vouloir refuser cette candidature ?</p>
              <div className="flex justify-end space-x-4 mt-4">
                <button onClick={() => setShowConfirmModal(false)} className="text-black bg-gray-200 rounded-md px-4 py-2 hover:bg-gray-300">
                  Annuler
                </button>
                <ButtonBlack
                isLoading={loading}
                  onClick={() => {
                    handleDeclineApplication();
                    
                  }}
                  className="text-white bg-red-500 rounded-md px-4 py-2 hover:opacity-80"
                >
                  Confirmer
                </ButtonBlack>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </AnimatePresence>
  );
};

export default DeclineApplicationModal;
